import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

interface PageHeaderProps {
    title: ReactNode
    description?: ReactNode
    actions?: ReactNode
    back?: {
        href: string
        label: string
    }
    className?: string
}

const PageHeader: FC<PageHeaderProps> = ({ title, description, actions, back, className }): ReactNode => {
    return (
        <header className={cn('mb-6 flex flex-col gap-4 lg:mb-8', className)}>
            {back && (
                <Link
                    href={back.href}
                    className='inline-flex w-fit items-center gap-1.5 rounded-md text-sm font-medium text-muted-foreground outline-none transition-colors hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/40'
                >
                    <ArrowLeft className='size-4' />
                    {back.label}
                </Link>
            )}

            <div className='flex flex-col gap-4 md:flex-row md:items-end md:justify-between'>
                <div className='flex min-w-0 flex-col gap-1.5'>
                    <h1 className='font-heading text-2xl font-bold tracking-tight text-foreground sm:text-[28px]'>
                        {title}
                    </h1>

                    {description && (
                        <div className='text-sm text-muted-foreground sm:text-[15px]'>
                            {description}
                        </div>
                    )}
                </div>

                {actions && (
                    <div className='flex flex-wrap items-center gap-2'>
                        {actions}
                    </div>
                )}
            </div>
        </header>
    )
}

export default PageHeader
